import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const CheckMarkV2 = ({
  spotFillColor = '#FFFFFF',
  spotHeight = '24',
  spotViewBox = '0 0 24 24',
  spotWidth = '24',
  ...svgProps
}: IconProps = {}): React.ReactElement => {
  return (
    <svg
      width={spotWidth}
      height={spotHeight}
      viewBox={spotViewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17.2443 9.66792C17.6132 9.25689 17.579 8.62464 17.1679 8.25577C16.7569 7.88689 16.1247 7.92107 15.7558 8.3321L10.7105 13.954L8.78091 11.542C8.4359 11.1107 7.8066 11.0408 7.37534 11.3858C6.94408 11.7308 6.87416 12.3601 7.21917 12.7914L9.88583 16.1247C10.0694 16.3542 10.3446 16.4913 10.6384 16.4996C10.9321 16.5079 11.2147 16.3866 11.4109 16.1679L17.2443 9.66792Z"
        fill={spotFillColor}
      />
    </svg>
  );
};
